@if (border) {
  <mat-card appearance="outlined">
    <header>
      <ng-content select="[la-loader-header]"></ng-content>
    </header>

    <mat-card-content>
      @if (mode === 'spinner') {
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
      }

      @if (mode === 'pulsing-logo') {
        <div class="pulse">
          <img src="assets/layout/short-logo-green.svg" alt="Pulsing logo" />
        </div>
      }
    </mat-card-content>

    <footer>
      <ng-content select="[la-loader-footer]"></ng-content>
    </footer>
  </mat-card>
} @else {
  <header>
    <ng-content select="[la-loader-header]"></ng-content>
  </header>

  @if (mode === 'spinner') {
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  }

  @if (mode === 'pulsing-logo') {
    <div class="pulse">
      <img src="assets/layout/short-logo-green.svg" alt="Pulsing logo" />
    </div>
  }

  <footer>
    <ng-content select="[la-loader-footer]"></ng-content>
  </footer>
}
